import { useCallback, useEffect, useState } from "react";
import { getBlockedUsers } from "../api/block";
import { messages } from "../constants/messages";

// Issue #126: ブロック一覧画面用。自分がブロックしたユーザー（表示用の情報付き）を取得・保持する
export const useBlockedUsers = () => {
  const [users, setUsers] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const res = await getBlockedUsers();
        if (cancelled) return;
        if (res?.status === 200 && Array.isArray(res?.data?.users)) {
          setUsers(res.data.users);
        } else {
          console.error("Failed to load blocked users:", res?.status);
          setError(messages.tryAgain);
        }
      } catch (err) {
        if (cancelled) return;
        console.error("Failed to load blocked users:", err);
        setError(messages.tryAgain);
      } finally {
        if (!cancelled) setIsLoaded(true);
      }
    };
    load();

    return () => {
      cancelled = true;
    };
  }, []);

  const removeUser = useCallback((id) => {
    setUsers((prev) => prev.filter((user) => user.id !== id));
  }, []);

  return { users, isLoaded, error, removeUser };
};

export default useBlockedUsers;
